module.exports = __webpack_public_path__ + "static/media/C033.85f56900.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C033.jpg
// module id = 316
// module chunks = 0